import useApi from '../hooks/useApi';
import ScrollReveal, { StaggerReveal, StaggerItem } from './ScrollReveal';

const PartnerCard = ({ name, description, logo_url, website_url }) => (
  <StaggerItem>
    <a
      href={website_url || '#'}
      target="_blank"
      rel="noopener noreferrer"
      className="card-minimal group flex flex-col items-center gap-5 p-8 hover:-translate-y-0.5 transition-all duration-300"
    >
      <div className="h-16 flex items-center justify-center">
        {logo_url ? (
          <img
            src={logo_url}
            alt={name}
            className="h-full max-w-[140px] object-contain grayscale group-hover:grayscale-0 transition-all duration-500"
          />
        ) : (
          <div className="h-16 w-16 rounded-2xl bg-stone-100 flex items-center justify-center text-stone-400 font-bold text-xl">
            {name?.[0]}
          </div>
        )}
      </div>
      <div className="w-8 h-px bg-stone-200 group-hover:bg-brand-800 transition-colors duration-300" />
      <div className="text-center">
        <p className="font-semibold text-stone-800 text-sm leading-snug group-hover:text-brand-800 transition-colors duration-300">
          {name}
        </p>
        {description && <p className="text-xs text-stone-400 mt-1">{description}</p>}
      </div>
      {website_url && (
        <span className="text-xs text-stone-300 group-hover:text-brand-800 transition-colors duration-300 font-medium tracking-wide">
          Visiter →
        </span>
      )}
    </a>
  </StaggerItem>
);

const Partenaires = () => {
  const { data: partners } = useApi('partners');

  if (!partners.length) return null;

  return (
    <section className="section-sm bg-stone-50 border-t border-stone-100">
      <div className="max-w-6xl mx-auto">
        <ScrollReveal className="text-center mb-12">
          <span className="eyebrow mb-3 block">Ils nous font confiance</span>
          <h2 className="display-md text-stone-950 mb-3">Nos Partenaires</h2>
          <p className="text-stone-400 text-sm max-w-md mx-auto">
            Des partenaires engagés qui partagent nos valeurs et soutiennent le développement du badminton à Éragny.
          </p>
        </ScrollReveal>

        <StaggerReveal className={`grid grid-cols-1 gap-5 ${
          partners.length === 1 ? 'sm:grid-cols-1 max-w-sm mx-auto' :
          partners.length === 2 ? 'sm:grid-cols-2 max-w-2xl mx-auto' :
          'sm:grid-cols-3'
        }`}>
          {partners.map(p => <PartnerCard key={p.id} {...p} />)}
        </StaggerReveal>
      </div>
    </section>
  );
};

export default Partenaires;
